import script from "./StandardEditForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./StandardEditForm.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__